// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-app {
  background-color: var(--ion-color-background) !important;
}
@supports (-webkit-touch-callout: none) {
  :host ion-app {
    --ion-safe-area-top: 60px;
  }
}
@supports not (-webkit-touch-callout: none) {
  :host ion-app {
    --ion-safe-area-top: 12px;
  }
}
:host ::ng-deep app-height-no-compatible {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACI;EACI,wDAAA;AAAR;AACQ;EAFJ;IAGQ,yBAAA;EAEV;AACF;AADQ;EALJ;IAMQ,yBAAA;EAIV;AACF;AAAI;EACI,aAAA;AAER","sourcesContent":[":host {\r\n    ion-app{\r\n        background-color: var(--ion-color-background) !important;\r\n        @supports (-webkit-touch-callout: none) {\r\n            --ion-safe-area-top: 60px;\r\n          }\r\n        @supports not (-webkit-touch-callout: none) {\r\n            --ion-safe-area-top: 12px;\r\n        }\r\n    }\r\n    \r\n\r\n    ::ng-deep app-height-no-compatible {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
